import axios from '../config/api'
import Vue from 'vue'

const state = () => ({
  submit: {
    data: null,
    isLoading: false,
    isSuccess: false,
    isError: false,
    errorMessage: '',
  },
})

// getters
const getters = {
  submitData: state => state.submit.data,
  isLoading: state => key => state[key].isLoading || false,
  isSuccess: state => key => state[key].isSuccess || false,
  isError: state => key => state[key].isError || false,
  errorMessage: state => key => state[key].errorMessage || '',
}

// actions
const actions = {
  async reminderRequest({ commit }, payload) {
    commit('submitRequest')

    const transformedPayload = {
      email: payload.email,
      phone: payload.phone,
      sku: payload.sku,
      bu: payload.bu,
    }

    await axios
      .post('/reminders', transformedPayload)
      .then(res => {
        commit('submitRequestSuccess', res.data)

        Vue.$toast.success(
          'ขอบคุณสำหรับความสนใจ เราจะแจ้งเตือนคุณเมื่อสินค้าพร้อมจำหน่าย',
          {
            duration: 5000,
            position: 'top',
          },
        )
      })
      .catch(error => {
        commit('submitRequestFailure', error.response.data.message)

        let message = error.response.data.message
          ? error.response.data.message
          : 'เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง'

        Vue.$toast.error(message, {
          duration: 5000,
          position: 'top',
        })
      })
  },
}

const mutations = {
  submitRequest(state) {
    state.submit = {
      data: null,
      isLoading: true,
      isSuccess: false,
      isError: false,
      errorMessage: '',
    }
  },

  submitRequestSuccess(state, data) {
    state.submit = {
      data: data,
      isLoading: false,
      isSuccess: true,
      isError: false,
      errorMessage: '',
    }
  },

  submitRequestFailure(state, errorMessage) {
    state.submit = {
      data: null,
      isLoading: false,
      isSuccess: false,
      isError: true,
      errorMessage:
        errorMessage || 'เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง',
    }
  },

  submitRequestReset(state) {
    state.submit = {
      data: null,
      isLoading: false,
      isSuccess: false,
      isError: false,
      errorMessage: '',
    }
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
